import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en_default from "./locales/en/default";
import ru_default from "./locales/ru/default.json";

/** Map localStorage "Lan" / browser locale → i18n code (`en` | `ru`). Unsupported → English. */
export function resolveAppLanguage() {
  try {
    const stored = localStorage.getItem("Lan");
    if (stored === "RU") return "ru";
    if (stored === "EN") return "en";
  } catch (_) {
    /* ignore */
  }

  const candidates = [];
  try {
    if (Array.isArray(navigator.languages)) candidates.push(...navigator.languages);
    if (navigator.language) candidates.push(navigator.language);
    if (navigator.userLanguage) candidates.push(navigator.userLanguage);
  } catch (_) {
    /* ignore */
  }

  const normalized = candidates.map((l) => String(l || "").toLowerCase());
  if (normalized.some((l) => l === "ru" || l.startsWith("ru-"))) return "ru";
  return "en";
}

const initialLng = resolveAppLanguage();

// Persist detected browser language once, so UI (language menu) stays in sync.
try {
  if (!localStorage.getItem("Lan")) {
    localStorage.setItem("Lan", initialLng === "ru" ? "RU" : "EN");
  }
} catch (_) {
  /* ignore */
}

i18n.use(initReactI18next).init({
  debug: false,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
  lng: initialLng,
  resources: {
    EN: {
      translation: en_default,
    },
    RU: {
      translation: ru_default,
    },
    en: {
      translation: en_default,
    },
    ru: {
      translation: ru_default,
    },
  },
});

export default i18n;
